import { render, staticRenderFns } from "./SafetyUpdate.vue?vue&type=template&id=267d19ba&scoped=true&"
import script from "./SafetyUpdate.vue?vue&type=script&lang=js&"
export * from "./SafetyUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267d19ba",
  null
  
)

export default component.exports